// extracted by mini-css-extract-plugin
module.exports = {"root":"ContentLoader_root__4wCNg","loader":"ContentLoader_loader__G-Kel","disabled":"ContentLoader_disabled__3GJSd"};